'use client';

import { Menu, MenuItem } from '@mui/material';
import Link from 'next/link';
import { useState } from 'react';
import { UserSettingsDialog } from '../dialog/UserSettingsDialog';
import { useSystemConfig } from '@/hooks/useSystemConfig';

interface SettingsMenuProps {
  anchorEl: null | HTMLElement;
  onClose: () => void;
}

export default function SettingsMenu({ anchorEl, onClose }: SettingsMenuProps) {
  const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);
  const systemConfig = useSystemConfig();

  // Return null if config is not initialized
  if (!systemConfig) {
    return null;
  }

  const handleOpenSettings = () => {
    setSettingsModalOpen(true);
    onClose();
  };

  const handleCloseSettings = () => {
    setSettingsModalOpen(false);
  };

  return (
    <>
      <Menu
        id="settings-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleOpenSettings}>User Settings</MenuItem>
        <MenuItem onClick={onClose} component={Link} href={systemConfig.basePath + '/settings/preferences'}>
          Preferences
        </MenuItem>
      </Menu>
      <UserSettingsDialog open={isSettingsModalOpen} onClose={handleCloseSettings} />
    </>
  );
}
